import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { loadingScreen } from "./boot/loading";
import { preloadAssets } from "./boot/preload";
import { legalPageFor } from "./ui/legal/LegalPage";
import { blips } from "./settings/audio";
import { SettingsProvider } from "./settings/SettingsContext";
import "./styles/app.css";
import { IN_DISCORD } from "./discord/activity";

// Inside Discord the Activity window is small: a more compact UI (see .in-discord in app.css).
if (IN_DISCORD) document.documentElement.classList.add("in-discord");

// Browsers only allow audio after a user gesture.
blips.installUnlock(window);

// The loading screen stays up until the 3D code and item pictures are ready
// (the plain /terms and /privacy pages need none of it).
const boot = loadingScreen();
if (legalPageFor(window.location.pathname)) boot.done();
else void preloadAssets(boot.progress).finally(boot.done);

const root = document.getElementById("root");
if (!root) throw new Error("#root missing");
createRoot(root).render(
  <StrictMode>
    <SettingsProvider>
      <App />
    </SettingsProvider>
  </StrictMode>,
);
